// --------------------------------------------------------------
// Created On: 2025-11-19
// Author: Marco Serrano
//
// Last Modified: 2025-11-19
// Modified By: Marco Serrano
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { format } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";

// Modifies a date so that it returns as if local time was pacific.
// We don't simply drop the times from all dates since that would mean that when we calculate a next day
// (for thanksgiving or christmas) we could be off by up to 8 hours.
export default function getDateAsPacific(localDate: Date): Date {
  const pacificTimeZone = "America/Los_Angeles";
  const dateStr = format(localDate, "yyyy-MM-dd");
  const pacificUtc = zonedTimeToUtc(`${dateStr}T00:00:00`, pacificTimeZone);
  return pacificUtc;
}
